import _slicedToArray from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.set";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module core/plugincollection
 */

/* globals console */
import CKEditorError, { attachLinkToDocumentation } from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * Manages a list of CKEditor plugins, including loading, resolving dependencies and initialization.
 *
 * @mixes module:utils/emittermixin~EmitterMixin
 */

var PluginCollection =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of the PluginCollection class.
   * Allows loading and initializing plugins and their dependencies.
   *
   * @param {module:core/editor/editor~Editor} editor
   * @param {Array.<Function>} [availablePlugins] Plugins (constructors) which the collection will be able to use
   * when {@link module:core/plugincollection~PluginCollection#init} is used with plugin names (strings, instead of constructors).
   * Usually, the editor will pass its built-in plugins to the collection so they can later be
   * used in `config.plugins` or `config.removePlugins` by names.
   */
  function PluginCollection(editor) {
    var availablePlugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, PluginCollection);

    /**
     * @protected
     * @member {module:core/editor/editor~Editor} module:core/plugin~PluginCollection#_editor
     */
    this._editor = editor;
    /**
     * Map of plugin constructors which can be retrieved by their names.
     *
     * @protected
     * @member {Map.<String|Function,Function>} module:core/plugin~PluginCollection#_availablePlugins
     */

    this._availablePlugins = new Map();
    /**
     * @protected
     * @member {Map} module:core/plugin~PluginCollection#_plugins
     */

    this._plugins = new Map();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = availablePlugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var PluginConstructor = _step.value;

        this._availablePlugins.set(PluginConstructor, PluginConstructor);

        if (PluginConstructor.pluginName) {
          this._availablePlugins.set(PluginConstructor.pluginName, PluginConstructor);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  /**
   * Iterable interface.
   *
   * Returns `[ PluginConstructor, pluginInstance ]` pairs.
   *
   * @returns {Iterable.<Array>}
   */


  _createClass(PluginCollection, [{
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function value() {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, entry;

      return regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 3;
              _iterator2 = this._plugins[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context.next = 13;
                break;
              }

              entry = _step2.value;

              if (!(typeof entry[0] == 'function')) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return entry;

            case 10:
              _iteratorNormalCompletion2 = true;
              _context.next = 5;
              break;

            case 13:
              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](3);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t0;

            case 19:
              _context.prev = 19;
              _context.prev = 20;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 22:
              _context.prev = 22;

              if (!_didIteratorError2) {
                _context.next = 25;
                break;
              }

              throw _iteratorError2;

            case 25:
              return _context.finish(22);

            case 26:
              return _context.finish(19);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[3, 15, 19, 27], [20,, 22, 26]]);
    })
    /**
     * Gets the plugin instance by its constructor or name.
     *
     *		// Check if 'Clipboard' plugin was loaded.
     *		if ( editor.plugins.has( 'Clipboard' ) ) {
     *			// Get clipboard plugin instance
     *			const clipboard = editor.plugins.get( 'Clipboard' );
     *
     *			this.listenTo( clipboard, 'inputTransformation', ( evt, data ) => {
     *				// Do something on clipboard input.
     *			} );
     *		}
     *
     * **Note**: This method will throw error if plugin is not loaded. Use `{@link #has editor.plugins.has()}`
     * to check if plugin is available.
     *
     * @param {Function|String} key The plugin constructor or {@link module:core/plugin~PluginInterface.pluginName name}.
     * @returns {module:core/plugin~PluginInterface}
     */

  }, {
    key: "get",
    value: function get(key) {
      var plugin = this._plugins.get(key);

      if (!plugin) {
        /**
         * The plugin is not loaded and could not be obtained.
         *
         * Plugin classes (constructors) need to be provided to the editor and must be loaded before they can be obtained from
         * the plugin collection.
         * This is usually done in CKEditor 5 builds by setting the {@link module:core/editor/editor~Editor.builtinPlugins}
         * property.
         *
         * **Note**: You can use `{@link module:core/plugincollection~PluginCollection#has editor.plugins.has()}`
         * to check if plugin was loaded.
         *
         * @error plugincollection-plugin-not-loaded
         * @param {String} plugin The name of the plugin which is not loaded.
         */
        var errorMsg = 'plugincollection-plugin-not-loaded: The requested plugin is not loaded.';
        var pluginName = key;

        if (typeof key == 'function') {
          pluginName = key.pluginName || key.name;
        }

        throw new CKEditorError(errorMsg, this._editor, {
          plugin: pluginName
        });
      }

      return plugin;
    }
    /**
     * Checks if plugin is loaded.
     *
     *		// Check if 'Clipboard' plugin was loaded.
     *		if ( editor.plugins.has( 'Clipboard' ) ) {
     *			// Now use clipboard plugin instance:
     *			const clipboard = editor.plugins.get( 'Clipboard' );
     *
     *			// ...
     *		}
     *
     * @param {Function|String} key The plugin constructor or {@link module:core/plugin~PluginInterface.pluginName name}.
     * @returns {Boolean}
     */

  }, {
    key: "has",
    value: function has(key) {
      return this._plugins.has(key);
    }
    /**
     * Initializes a set of plugins and adds them to the collection.
     *
     * @param {Array.<Function|String>} plugins An array of {@link module:core/plugin~PluginInterface plugin constructors}
     * or {@link module:core/plugin~PluginInterface.pluginName plugin names}. The second option (names) works only if
     * `availablePlugins` were passed to the {@link #constructor}.
     * @param {Array.<String|Function>} [removePlugins] Names of plugins or plugin constructors
     * that should not be loaded (despite being specified in the `plugins` array).
     * @returns {Promise.<module:core/plugin~LoadedPlugins>} A promise which gets resolved once all plugins are loaded
     * and available in the collection.
     */

  }, {
    key: "init",
    value: function init(plugins) {
      var removePlugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var that = this;
      var editor = this._editor;
      var loading = new Set();
      var loaded = [];
      var pluginConstructors = mapToAvailableConstructors(plugins);
      var removePluginConstructors = mapToAvailableConstructors(removePlugins);
      var missingPlugins = getMissingPluginNames(plugins);

      if (missingPlugins) {
        /**
         * Some plugins are not available and could not be loaded.
         *
         * Plugin classes (constructors) need to be provided to the editor before they can be loaded by name.
         * This is usually done in CKEditor 5 builds by setting the {@link module:core/editor/editor~Editor.builtinPlugins}
         * property.
         *
         * **If you see this warning when using one of the {@glink builds/index CKEditor 5 Builds}**, it means
         * that you try to enable a plugin which was not included in that build. This may be due to a typo
         * in the plugin name or simply because that plugin is not a part of this build. In the latter scenario,
         * read more about {@glink builds/guides/development/custom-builds custom builds}.
         *
         * **If you see this warning when using one of the editor creators directly** (not a build), then it means
         * that you tried loading plugins by name. However, unlike CKEditor 4, CKEditor 5 does not implement a "plugin loader".
         * This means that CKEditor 5 does not know where to load the plugin modules from. Therefore, you need to
         * provide each plugin through reference (as a constructor function). Check out the examples in
         * {@glink builds/guides/integration/advanced-setup#scenario-2-building-from-source "Building from source"}.
         *
         * @error plugincollection-plugin-not-found
         * @param {Array.<String>} plugins The name of the plugins which could not be loaded.
         */
        var errorMsg = 'plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.'; // Log the error so it's more visible on the console. Hopefully, for better DX.

        console.error(attachLinkToDocumentation(errorMsg), {
          plugins: missingPlugins
        });
        return Promise.reject(new CKEditorError(errorMsg, this._editor, {
          plugins: missingPlugins
        }));
      }

      return Promise.all(pluginConstructors.map(loadPlugin)).then(function () {
        return initPlugins(loaded, 'init');
      }).then(function () {
        return initPlugins(loaded, 'afterInit');
      }).then(function () {
        return loaded;
      });

      function loadPlugin(PluginConstructor) {
        if (removePluginConstructors.includes(PluginConstructor)) {
          return;
        } // The plugin is already loaded or being loaded - do nothing.


        if (that._plugins.has(PluginConstructor) || loading.has(PluginConstructor)) {
          return;
        }

        return instantiatePlugin(PluginConstructor).catch(function (err) {
          /**
           * It was not possible to load the plugin.
           *
           * This is a generic error logged to the console when a JavaSript error is thrown during the initialization
           * of one of the plugins.
           *
           * If you correctly handled the promise returned by the editor's `create()` method (like shown below)
           * you will find the original error logged to the console, too:
           *
           *		ClassicEditor.create( document.getElementById( 'editor' ) )
           *			.then( editor => {
           *				// ...
           * 			} )
           *			.catch( error => {
           *				console.error( error );
           *			} );
           *
           * @error plugincollection-load
           * @param {String} plugin The name of the plugin that could not be loaded.
           */
          console.error(attachLinkToDocumentation('plugincollection-load: It was not possible to load the plugin.'), {
            plugin: PluginConstructor
          });
          throw err;
        });
      }

      function initPlugins(loadedPlugins, method) {
        return loadedPlugins.reduce(function (promise, plugin) {
          if (!plugin[method]) {
            return promise;
          }

          return promise.then(plugin[method].bind(plugin));
        }, Promise.resolve());
      }

      function instantiatePlugin(PluginConstructor) {
        return new Promise(function (resolve) {
          loading.add(PluginConstructor);

          if (PluginConstructor.requires) {
            PluginConstructor.requires.forEach(function (RequiredPluginConstructorOrName) {
              var RequiredPluginConstructor = getPluginConstructor(RequiredPluginConstructorOrName);

              if (removePlugins.includes(RequiredPluginConstructor)) {
                /**
                 * Cannot load a plugin because one of its dependencies is listed in the `removePlugins` option.
                 *
                 * @error plugincollection-required
                 * @param {Function} plugin The required plugin.
                 * @param {Function} requiredBy The parent plugin.
                 */
                throw new CKEditorError('plugincollection-required: Cannot load a plugin because one of its dependencies is listed in' + 'the `removePlugins` option.', editor, {
                  plugin: RequiredPluginConstructor,
                  requiredBy: PluginConstructor
                });
              }

              loadPlugin(RequiredPluginConstructor);
            });
          }

          var plugin = new PluginConstructor(editor);

          that._add(PluginConstructor, plugin);

          loaded.push(plugin);
          resolve();
        });
      }

      function getPluginConstructor(PluginConstructorOrName) {
        if (typeof PluginConstructorOrName == 'function') {
          return PluginConstructorOrName;
        }

        return that._availablePlugins.get(PluginConstructorOrName);
      }

      function getMissingPluginNames(plugins) {
        var missingPlugins = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = plugins[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var pluginNameOrConstructor = _step3.value;

            if (!getPluginConstructor(pluginNameOrConstructor)) {
              missingPlugins.push(pluginNameOrConstructor);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return missingPlugins.length ? missingPlugins : null;
      }

      function mapToAvailableConstructors(plugins) {
        return plugins.map(function (pluginNameOrConstructor) {
          return getPluginConstructor(pluginNameOrConstructor);
        }).filter(function (PluginConstructor) {
          return !!PluginConstructor;
        });
      }
    }
    /**
     * Destroys all loaded plugins.
     *
     * @returns {Promise}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var promises = Array.from(this).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            pluginInstance = _ref2[1];

        return pluginInstance;
      }).filter(function (pluginInstance) {
        return typeof pluginInstance.destroy == 'function';
      }).map(function (pluginInstance) {
        return pluginInstance.destroy();
      });
      return Promise.all(promises);
    }
    /**
     * Adds the plugin to the collection. Exposed mainly for testing purposes.
     *
     * @protected
     * @param {Function} PluginConstructor The plugin constructor.
     * @param {module:core/plugin~PluginInterface} plugin The instance of the plugin.
     */

  }, {
    key: "_add",
    value: function _add(PluginConstructor, plugin) {
      this._plugins.set(PluginConstructor, plugin);

      var pluginName = PluginConstructor.pluginName;

      if (!pluginName) {
        return;
      }

      if (this._plugins.has(pluginName)) {
        /**
         * Two plugins with the same {@link module:core/plugin~PluginInterface.pluginName} were loaded.
         * This will lead to runtime conflicts between these plugins.
         *
         * In practice, this warning usually means that new plugins were added to an existing CKEditor 5 build.
         * Plugins should always be added to a source version of the editor (`@ckeditor/ckeditor5-editor-*`),
         * not to an editor imported from one of the `@ckeditor/ckeditor5-build-*` packages.
         *
         * Check your import paths and the list of plugins passed to
         * {@link module:core/editor/editor~Editor.create `Editor.create()`}
         * or specified in {@link module:core/editor/editor~Editor.builtinPlugins `Editor.builtinPlugins`}.
         *
         * The second option is that your `node_modules/` directory contains duplicated versions of the same
         * CKEditor 5 packages. Normally, on clean installations, npm deduplicates packages in `node_modules/`, so
         * it may be enough to call `rm -rf node_modules && npm i`. However, if you installed conflicting versions
         * of packages, their dependencies may need to be installed in more than one version which may lead to this
         * warning.
         *
         * Technically speaking, this error occurs because after adding a plugin to an existing editor build
         * dependencies of this plugin are being duplicated.
         * They are already built into that editor build and now get added for the second time as dependencies
         * of the plugin you are installing.
         *
         * Read more about {@glink builds/guides/integration/installing-plugins installing plugins}.
         *
         * @error plugincollection-plugin-name-conflict
         * @param {String} pluginName The duplicated plugin name.
         * @param {Function} plugin1 The first plugin constructor.
         * @param {Function} plugin2 The second plugin constructor.
         */
        throw new CKEditorError('plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.', null, {
          pluginName: pluginName,
          plugin1: this._plugins.get(pluginName).constructor,
          plugin2: PluginConstructor
        });
      }

      this._plugins.set(pluginName, plugin);
    }
  }]);

  return PluginCollection;
}();

export { PluginCollection as default };
mix(PluginCollection, EmitterMixin);